import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { useCurrentRawSnapshotsQuery } from "@/features/experience-curation/queries/useRawSnapshotsQuery";
import { useHasCommercialFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { useTitleValidation } from "@/features/experience-shared/composables/useTitleValidation";

export const useCurationTitle = defineStore("curation-setting-title-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const translationsQuery = useCurrentExperienceTranslationsQuery();
  const rawSnapshotsQuery = useCurrentRawSnapshotsQuery();

  const initialValue = computed(() => translationsQuery.data.value?.title ?? "");
  const { model, hasChanges, isFilled, errors, errorMessage, isValid, reset } = useTitleValidation(initialValue);

  const isRequired = true;

  const rawTitle = computed(() => rawSnapshotsQuery.data.value?.rawSnapshot?.raw?.commercial?.title || "");
  const publishedRawTitle = computed(
    () => rawSnapshotsQuery.data.value?.publishedRawSnapshot?.raw?.commercial?.title || ""
  );
  const hasUnpublishedChange = useHasCommercialFieldChange("title");
  const showRawFields = computed(() => curationExperienceStore.showRawFields);
  const isReadonly = computed(() => curationExperienceStore.isReadonly);

  return {
    id: "title",
    model,
    isRequired,
    isReadonly,
    isFilled,
    errors,
    errorMessage,
    isValid,
    hasChanges,
    hasUnpublishedChange,
    rawTitle,
    publishedRawTitle,
    showRawFields,
    reset,
  };
});
